import { useFormikContext } from 'formik';
import { DueDateField } from '../../components';
import { useRfiForm } from '../RfiFormProvider';
import { ISSUE_ATTRIBUTE_NAMES } from '../../constants/issue-attribute-names';
import { RfiCreateFormValues } from '../types';

const nowInIsoString = new Date().toISOString();

const DueDate = () => {
  const formik = useFormikContext<RfiCreateFormValues>();
  const { mandatoryFields, isSubmitting, refs } = useRfiForm();
  const fieldName = ISSUE_ATTRIBUTE_NAMES.DUE_DATE;
  const isFieldsMandatory = mandatoryFields.includes(fieldName);
  const errorMessage = (formik.touched[fieldName] && formik.errors[fieldName]) as
    | string
    | false
    | undefined;
  const dateValue = formik.values[fieldName] || null;

  return (
    <DueDateField
      required={isFieldsMandatory}
      error={errorMessage}
      ref={refs[fieldName]}
      date={dateValue}
      onChange={(date) => {
        formik.setFieldValue(fieldName, date);
      }}
      disabled={isSubmitting}
      rfiCreatedAt={nowInIsoString}
    />
  );
};
export default DueDate;
